import RenameList from './RenameList';

export default RenameList;
